module.exports = __webpack_public_path__ + "img/pointOfSale.f93f6046.svg";